import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Sisäänkirjautuminen",
    component: Login,
  },
  {
    path: "/home",
    name: "Kivirannan varaus",
    component: Home,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
